import { SVGProps } from 'react'

import { wrapIcon } from '../wrap-icon'

function SvgFolder(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 3a3 3 0 0 1 3 3v1h6a3 3 0 0 1 3 3v8l-.004.154A3 3 0 0 1 19 21H5a3 3 0 0 1-2.996-2.846L2 18V6a3 3 0 0 1 3-3h5ZM4 9v9l.005.102A1 1 0 0 0 5 19h14a1 1 0 0 0 .995-.898L20 18v-8a1 1 0 0 0-1-1H4Zm1-4a1 1 0 0 0-1 1v1h7V6a1 1 0 0 0-1-1H5Z"
        fill="currentColor"
      />
    </svg>
  )
}
export default wrapIcon(SvgFolder)
